import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Observable } from 'rxjs';

import { LiveSearchSelectComponent } from './../../../../../shared/live-search-select';
import { DatePickerComponent } from './../../../../../shared/date-picker';
import { Product } from '../../../../../_models/Interfaces';
import { Lessee } from '../../../../../_models';

@Component({
    selector: 'app-agreement',
    templateUrl: './agreement.component.html',
    styleUrls: ['./agreement.component.scss']
})
export class AgreementComponent implements OnInit {
    @Input() data: any; // required. Agreement model to handle data
    @Input() product: Product;
    @Input() agreementIdKey: string = "id";
    @Input() nameLabel: string;
    @Input() headers = {
        concept: 'Concepto',
        data: 'Valor',
        page: 'Página de contrato'
    };
    @Input() selectionTexts = {
        label: "Asignar otro",
        notFound: "No encontrado",
        loading: "Cargando...",
        none: "Ninguno"
    };
    @Input() texts = {
        save: 'Guardar',
        upload: 'Subir archivo de nuevo',
        selectFile: 'Seleccione archivo',
        detail: 'Detalle',
        startDate: 'Fecha inicio',
        endDate: 'Fecha fin',
        amount: 'Precio de renta',
        signatory: 'Arrendatario'
    };

    dateTexts = {
        label: "",
        placeholder: ""
    }

    LesseeTexts = {
        notFound: "No encontrado",
        none: "Seleccionar arrendatario"
    };

    accept = 'image/jpeg,image/png,application/pdf';
    validation_messages = {
        'name': [{ type: 'required', message: 'Campo requerido.' }],
        'date_begin': [{ type: 'required', message: 'Campo requerido.' }],
        'date_begin_page': [{ type: 'required', message: 'Campo requerido.' }],
        'date_expires': [{ type: 'required', message: 'Campo requerido.' }],
        'date_expires_page': [{ type: 'required', message: 'Campo requerido.' }],
        'amount': [{ type: 'required', message: 'Campo requerido.' }],
        'amount_page': [{ type: 'required', message: 'Campo requerido.' }],
        'lessee_id': [{ type: 'required', message: 'Campo requerido.' }],
        'lessee_page': [{ type: 'required', message: 'Campo requerido.' }]
    }
    additionalEntry = 'Nuevo';
    isNew: boolean = true;
    invalid: boolean = true;
    @ViewChild('formEl') formEl;
    @ViewChild('selection') selection: LiveSearchSelectComponent;
    @ViewChild('lesseeSelection') lesseeSelection: LiveSearchSelectComponent;
    @ViewChild('startDate') startDate: DatePickerComponent;
    @ViewChild('endDate') endDate: DatePickerComponent;

    form: FormGroup;
    request$: Observable<Object>;
    file: File;

    constructor(protected lesseData: Lessee, private _fb: FormBuilder) { }

    ngOnInit() {
        this.form = this._fb.group({
            [this.agreementIdKey]: [0],
            'file': [''],
            'name': [null, Validators.compose([Validators.required])],
            'date_begin': ['', Validators.compose([Validators.required])],
            'date_begin_page': [1, Validators.compose([Validators.required])],
            'date_expires': ['', Validators.compose([Validators.required])],
            'date_expires_page': [1, Validators.compose([Validators.required])],
            'amount': ['', Validators.compose([Validators.required])],
            'amount_page': [1, Validators.compose([Validators.required])],
            'lessee_id': ['', Validators.compose([Validators.required])],
            'lessee_page': [1, Validators.compose([Validators.required])],
            'comments': [null]
        });
        this.form.valueChanges.subscribe(formValue => {
            let invalidPrev: boolean = !this.isNew && !this.form.valid;
            let invalidNew: boolean =
                this.isNew && (!this.form.valid || !this.form.value.file || !this.form.value.name);
            this.invalid = invalidPrev || invalidNew;
            this.makeRequest();
        });
        this.data.changed$.subscribe((data) => {
            this.selection.listing();
        })
        this.lesseData.changed$.subscribe((lessee) => {
            this.form.controls.lessee_id.setValue(lessee.id);
        })
        this.getThisAgreement();
    }

    getThisAgreement() {
        this.data.getFromProduct(this.product).subscribe(value => {
            this.changeAgreement(value);
        });
    }

    changeAgreement(selected: any) {
        if (this.isNewAgreement(selected)) {
            this.isNew = true;
            this.form.controls[this.agreementIdKey].setValue(0);
            this.form.reset();
            this.startDate.clear();
            this.endDate.clear();
            this.lesseeSelection.clear();
            return;
        }
        this.isNew = false;
        this.form.setValue(selected.pick(this.form.value));
        this.startDate.setDate(this.form.value.date_begin);
        this.endDate.setDate(this.form.value.date_expires);
        this.form.controls.lessee_id.setValue(selected.lessee.id);
        this.lesseData.instance = selected.lessee;
        this.lesseeSelection.listing();
    }

    makeRequest() {
        if (this.data) {
            let form = new FormData(this.formEl.nativeElement);
            if (this.form.value[this.agreementIdKey]) {
                form.set(this.agreementIdKey, this.form.value[this.agreementIdKey]);
            }
            else {
                form.set(this.agreementIdKey, '0');
                form.set('file', this.file);
            }
            form.set('name', this.form.value['name']);
            form.set('date_begin', this.form.value['date_begin']);
            form.set('date_expires', this.form.value['date_expires']);
            form.set('lessee_id', this.form.value['lessee_id']);
            this.request$ = this.data.post(this.product, form);
        }
    }

    startChanged(date) {
        this.form.controls.date_begin.setValue(date.string);
    }
    endChanged(date) {
        this.form.controls.date_expires.setValue(date.string);
    }


    error(error) {
        console.error(error);
    }

    agreementUpdated() {
        this.getThisAgreement();
    }
    // reference: https://stackoverflow.com/questions/44072909/using-reactive-form-validation-with-input-type-file-for-an-angular-app/44238894
    // fix: formcontrolname not yet implemented for input type=file
    onFileChange($event) {
        this.file = $event.target.files[0]; // <--- File Object for future use.
        this.form.controls['file'].setValue(this.file ? this.file.name : ''); // <-- Set Value for Validation
    }

    private isNewAgreement(agreement) {
        return (agreement == this.additionalEntry) || (this.data && this.data.empty());
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/units/agreement/agreement.component.ts